 
var h2Elements = $('.dt-sc-blog-description-left').find('h2');

if (h2Elements.length > 0) {
  var ulElement = $('<ul>'); // Create a new unordered list element
  
  h2Elements.each(function(index, element) {
      var h2Text = $(element).text();
      var h2Id = 'h2-id-' + index; // Generate a unique id for each h5 element
      $(element).attr('id', h2Id); // Add the id attribute to the h5 element
      var linkHref = '#' + h2Id; // Create a link based on the h5 element's id
      var aElement = $('<a>').attr('href', linkHref).text(h2Text); // Create a new anchor element with the dynamically generated href and text
      var liElement = $('<li>').append(aElement); // Create a new list item element and append the anchor element to it
      ulElement.append(liElement); // Append the list item to the unordered list
  });  
  $('.bloghighlights-left , .bloghighlights-right').append(ulElement); // Append the unordered list to the desired container
} else {
  $('.bloghighlights-left , .bloghighlights-right').hide(); // Hide the dt-sc-blog-description-left element if no h5 elements are found
}
  // top se space k liye code
$(document).ready(function() {
    // Add click event listener to all anchor links inside #bloghighlights
    $('#bloghighlights a').on('click', function(event) {
        // Prevent the default behavior of the anchor link
        event.preventDefault();

        // Get the target element's offset from the top
        var targetOffset = $($(this).attr('href')).offset().top;

        // Scroll to the target element with an offset of 50px from the top
        $('html, body').animate({
            scrollTop: targetOffset - 70
        }, 500); // You can adjust the duration of the animation if needed
    });
});
$(document).ready(function() {
    // Function to show/hide blog description based on screen size
    function showHideBlogDescription() {
        if ($(window).width() >= 768) {
            $('.bloghighlights-left').hide();
            $('.bloghighlights-right').show();
        } else {
            $('.bloghighlights-left').show();
            $('.bloghighlights-right').hide();
        }
    }

    // Call the function initially
    showHideBlogDescription();

    // Call the function again whenever the window is resized
    $(window).resize(function() {
        showHideBlogDescription();
    });
});        